exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-link {\n  background-color: #FFF;\n  padding: 1.5rem; }\n  .preview-link__link {\n    color: #7bbeca;\n    display: block;\n    letter-spacing: .04em;\n    text-decoration: none; }\n", ""]);

// exports
